import HeroImage from "../../assets/img/HeroImage.png";

export default function ProductDetailHero() {
  return (
    <section className="relative h-[450px] overflow-hidden">
      <img
        src={HeroImage}
        alt="Hero"
        className="absolute inset-0 w-full h-full object-cover"
      />

      <div className="absolute inset-0 bg-gradient-to-r from-[#63BEC2]/70 to-[#324A5A]/70" />

      <div className="relative z-10 max-w-6xl mx-auto px-8 h-full flex items-center">
        <h1 className="text-white text-5xl font-bold">Detail Product</h1>
      </div>
    </section>
  );
}
